import { UpToDateBuildService, BackendLoggingLevel } from './../../services/up-to-date-build.service';
import { AcumaticaService } from './../../acumatica/acumatica.service';
import { LogService } from './../../services/logging.service';
import { NotFoundError } from 'src/app/acumatica/acumatica-errors';
import { FeedbackSnackbarComponent } from 'src/app/common/feedback-snackbar/feedback-snackbar.component';
import { ConfirmationDialog } from '../../common/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TransferService } from '../../acumatica/EntityServices/TransferOrder.service';
import { InventorySummaryDetail, InventorySummaryInquiry, InventorySummaryInquiryService } from '../../acumatica/EntityServices/InventorySummaryInquiry.service';
import { Router } from '@angular/router';
import { StockItem, StockItemService } from '../../acumatica/EntityServices/StockItem.service';
import { ApplicationScreen } from '../../application-navigator/application-screen';
import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { WarehouseService } from '../../acumatica/EntityServices/Warehouse.service';
import { AlertDialog } from '../../common/alert-dialog/alert-dialog.component';
import { Transfer, TransferDetail } from '../../acumatica/EntityServices/TransferOrder.service';
import { Observable } from 'rxjs';
import { AudioService, Sound } from 'src/app/services/audio.service';

@Component({
  selector: 'app-location-transfer',
  templateUrl: './location-transfer.component.html',
  styleUrls: ['./location-transfer.component.css']
})
export class LocationTransferComponent extends ApplicationScreen implements AfterViewInit {
  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private inventoryInquiry: InventorySummaryInquiryService,
    private warehouses: WarehouseService,
    private stockItems: StockItemService,
    private transfers: TransferService,
    private logger: LogService,
    private acumatica: AcumaticaService,
    private audio: AudioService,
    buildService: UpToDateBuildService
  ) {
    super();

    this.warehouseID.valueChanges.subscribe(value => {
      this.transfer.FromWarehouseID = value;
      this.transfer.ToWarehouseID = value;
    });

    buildService.componentLogging.TransferPutaway.subscribe(level => {
      this.acumatica.logComponentAPIRequestsToBackend =
        level == BackendLoggingLevel.AcumaticaAPIs
        || level == BackendLoggingLevel.Extensive
    });
  }

  @ViewChild('transferSetupDialog') transferSetupDialog!: TemplateRef<any>;
  @ViewChild('selectSourceLocation') selectSourceLocationDialog!: TemplateRef<any>;
  @ViewChild('getTransferQuantity') getTransferQuantityDialog!: TemplateRef<any>;
  @ViewChild('changePrimaryBin') changePrimaryBin!: TemplateRef<any>;
  pageTitle = "Transfer / Put-away";

  screenMenuItems = [
    {
      icon: 'restart_alt',
      label: 'Reset Warehouse Locations',
      handler: () => {
        this.warehouses.clearCachedLocations(this.warehouseID.value);
        this.ngAfterViewInit();
      }
    },
    {
      icon: 'museum',
      label: 'Change Primary Bin',
      handler: () => this.ChangePrimaryBin()
    }
  ];

  // the in-process transfer document being built
  transfer = new Transfer();
  // the most recently scanned Inventory Item (to display default location)
  item?: StockItem;

  // working warehouse -- input from dialog
  warehouseID = new FormControl(); // TODO: replace with common\warehouse-selector-dialog
  // when transfering non-Rolled items to transfer, they may be in multiple locations -- input from dialog
  selectPieceFromLocation = new FormControl();
  // when transfering non-Rolled items, dialog prompt for quantity to transfer
  transferQuantity = new FormControl();
  // when re-homing items, dialog prompt for item & new home bin location
  rehomeInventoryID = new FormControl();
  rehomeLocationID = new FormControl();
  // list of bin Locations within the warehouse to quickly check for location scan before async Item.get
  locations: string[] = [];
  // dictionary of inventory item records
  inventoryItems: { [key: string]: Promise<StockItem> } = {};
  // dictionary of inventory summary inquiry results per item
  itemInventorySummaries: { [key: string]: Promise<InventorySummaryInquiry> } = {};
  // collection of transfers batched into a single destination location scan
  pendingTransfers: TransferDetail[] = [];
  // batch table column definition
  pendingTransfersColumns = ['InventoryID', 'LotSerNbr', 'Qty', 'FromLocationID', 'Menu'];
  documentDetailsColumns = ['InventoryID', 'LotSerNbr', 'Qty', 'FromLocationID', 'ToLocationID'];

  // main entry form
  scannerInput = new FormGroup({
    Item: new FormControl(),
    LotSerNbr: new FormControl(),
    FromLocation: new FormControl(),
    AutoDOCK00: new FormControl(),
  });
  focusInput = () => { (<any>this.scannerInput.get('Item')).focus(); }

  ngAfterViewInit(): void {
    // open setup dialog to prompt for Warehouse
    this.dialog.open(this.transferSetupDialog).afterClosed().subscribe(confirmed => {
      if (!confirmed) { this.router.navigate(['/']); return; }

      // get warehouse locations if needed
      this.warehouses.getLocations(this.warehouseID.value).subscribe(locations => {
        this.locations = locations;
      });

      this.focusInput();
    });
  }

  /**
   * when scanning QR with item and lot num both process functions are triggered
   * prevent double creation of transfer detail
   * returns true if a preventDoubleScan was called within 100 ms previously
   *    if( this.preventDoubleScan() ) return;
   */
  preventDoubleScan(): boolean {
    const this_fn = <any>this.preventDoubleScan;
    if (this_fn.firstScanReceived) return true;
    this_fn.firstScanReceived = true;
    setTimeout(() => this_fn.firstScanReceived = false, 100);
    return false;
  }

  /**
   * Directs processing of a scanned in Inventory ID or Bin Location
   */
  processItemInput() {
    if (this.preventDoubleScan()) return;

    let inventoryID = this.scannerInput.get('Item')!.value;
    if (!inventoryID) return;

    // check if the 'inventoryID' is actully a bin location
    let whseLocationIndex = this.locations.indexOf(inventoryID);

    // scanned a bin location
    if (whseLocationIndex > -1) {
      this.waitForPendingPiecesToComplete().then(() => {
        this.stagePendingTransfers(this.locations[whseLocationIndex]);
      });
    }

    // presumably scanned an Inventory ID
    else
      this.selectTransferPiece(inventoryID);
  }

  processLotNumInput() {
    if (this.preventDoubleScan()) {
      this.prepareForNextItemInput();
      return;
    }
    let inventoryID = this.scannerInput.get('Item')!.value;
    this.selectTransferPiece(inventoryID).then(() => {
      this.prepareForNextItemInput();
    });
  }

  /**
   * returns a Promise that resolves with the given inventory id's stock item
   */
  getStockItem(inventoryID: string): Promise<StockItem> {
    // if inventory data for the item is not already fetched
    if (this.inventoryItems[inventoryID] === undefined) {
      // send the inquiry to Acumatica & hold results via Promise
      this.inventoryItems[inventoryID] = new Promise<StockItem>((resolve, reject) => {
        this.stockItems.get(inventoryID, {
          loader: null
        }).subscribe(resolve, reject);
      });
    }

    // return the inventory promise for the item
    return this.inventoryItems[inventoryID];
  }

  /**
   * Returns a Promise that resolves with the given inventory id's inventory data
   */
  getItemInventorySummary(inventoryID: string): Promise<InventorySummaryInquiry> {
    // if invenotry data for the item is not already fetched
    if (this.itemInventorySummaries[inventoryID] === undefined) {
      // create the inquiry
      let inquiry = new InventorySummaryInquiry({
        WarehouseID: this.warehouseID.value,
        InventoryID: inventoryID
      });

      // send the inquiry to Acumatica & hold results via Promise
      this.itemInventorySummaries[inventoryID] = new Promise<InventorySummaryInquiry>((resolve, reject) => {
        this.inventoryInquiry.get(inquiry, {
          loader: null
        }).subscribe(resolve, reject);
      });
    }

    // return the inventory promise for the item
    return this.itemInventorySummaries[inventoryID];
  }

  _pieceSelectCount: number = 0;

  /**
   * Determine the Piece and Quantity to transfer based on the type Inventory Item
   */
  selectTransferPiece(inventoryID: string): Promise<void> {
    return new Promise<void>(done => {
      const lotSerNbr = this.scannerInput.get('LotSerNbr')!.value;

      let snackbarRef = this.snackBar.openFromComponent(FeedbackSnackbarComponent, { data: { message: "Getting item " + inventoryID } });
      ++this._pieceSelectCount;

      this.getStockItem(inventoryID)
        .then(item => {
          snackbarRef.dismiss();

          if (item?.InventoryID == undefined) {
            this.dialog.open(AlertDialog, { data: { message: "No inventory item with ID \"" + inventoryID + "\" could be loaded" } });
            --this._pieceSelectCount;
            done();
            return;
          }

          this.item = item;
          inventoryID = item.InventoryID.trim().toUpperCase(); // ensure casing

          // if it's a Lot / Serial item and no Lot Serial Number entered yet
          if (item.isLotSerItem && !lotSerNbr) {
            // focus field and return to wait
            --this._pieceSelectCount;
            (<any>this.scannerInput.get('LotSerNbr')).focus();
            return;
          }

          // get the inventory data for the item
          snackbarRef = this.snackBar.openFromComponent(FeedbackSnackbarComponent, { data: { message: "Getting item " + inventoryID + " inventory" } });
          this.getItemInventorySummary(inventoryID)
            .then(inventory => {
              --this._pieceSelectCount;
              snackbarRef.dismiss();

              // for pieces in "LOST" use the QtyOnHand for the QtyAvailable
              // (because "LOST" is flagged to not include in QtyAvailable, Acumatica returns it as zero)
              inventory.Results.forEach(piece => piece.QtyAvailable = piece.QtyOnHand);

              // find the piece(s) with the given Lot / Serial number (or all sources if no Lot/Serial)
              let pieces = inventory.Results.filter(piece =>
                piece.LotSerialNbr == lotSerNbr
                // exclude items on SO's not yet shipped
                && (piece.QtyAvailable > 0)
                // rolled goods should filter to matching Lot Serial Nbr (if keyed item #, Lot will be null)
                // non-rolled goods can return any item
                && (item.isRolledGood ? piece.LotSerialNbr != null : true));

              if (pieces.length > 1 && this.scannerInput.get('AutoDOCK00')!.value) {
                let DockPieces = pieces.filter(piece => piece.LocationID == 'DOCK00');
                if (DockPieces.length == 1) pieces = DockPieces;
              }

              // not found, single match, or multiple matches
              switch (pieces.length) {
                case 0:
                  let message = "Inventory record not found\nInventory ID: " + inventoryID;
                  if (lotSerNbr !== null) message += "\nLot/Ser Nbr: " + lotSerNbr
                  this.alertAndCancel(message);
                  // this.prepareForNextItemInput();
                  done();
                  return;
                case 1:
                  this.addToPendingTransfers(item, pieces[0]);
                  done();
                  break;
                default:
                  // multiple locations
                  this.audio.play(Sound.GentleBeep);
                  this.selectSourceLocation(item, pieces).subscribe({
                    next: (piece) => {
                      if (piece) this.addToPendingTransfers(item, piece);
                    },
                    complete: () => {
                      done();
                      this.prepareForNextItemInput();
                    }
                  });
                  break;
              }
            })
            .catch(err => {
              // such as invalid Inventory ID entered
              --this._pieceSelectCount;
              snackbarRef.dismiss();
              done();
              throw err;
            })
        })
        .catch(err => {
          --this._pieceSelectCount;
          snackbarRef.dismiss();

          console.error(err);
          this.item = undefined
          done();

          if (err instanceof NotFoundError) {
            this.alertAndCancel("\"" + inventoryID + "\" is not a valid Inventory ID or Location ID");
            this.prepareForNextItemInput();
            return;
          }
          else {
            done();
            throw err;
          }
        });
    });
  }

  addToPendingTransfers(item: StockItem, piece: InventorySummaryDetail): void {
    let transferSearch = (trans: TransferDetail) => trans.InventoryID == item.InventoryID && trans.LotSerialNbr == piece.LotSerialNbr;
    if (item.isRolledGood) {
      // search for and remove the same item in the pending transfers
      let matchingTransfer = this.pendingTransfers.find(transferSearch);
      if (matchingTransfer) {
        this.audio.play(Sound.ErrorBeep);
        this.alertAndCancel("That item is already in the pending transfers");
        return;
      }

      // search for and remove the same item in the staged transfers
      matchingTransfer = this.transfer.Details.find(transferSearch);
      if (matchingTransfer) {
        this.dialog.open(ConfirmationDialog, {
          data: {
            message: "That item was already in your transfer document. Are you moving it to a different location than '" + matchingTransfer.ToLocationID + "'?",
            confirmText: "Yes"
          }
        }).afterClosed().subscribe(answer => {
          if (answer) {
            // remove the previous transfer detail and allow this one to be entered
            this.transfer.Details.splice(this.transfer.Details.indexOf(matchingTransfer!), 1);
            // refresh the Review table UI
            this.transfer.Details = this.transfer.Details.concat();
          } else {
            this.cancelPendingTransfer(this.pendingTransfers.find(transferSearch)!);
            // this.prepareForNextItemInput();
            return;
          }
        });
      }
    }

    // all good, proceed with queuing to pending transfers
    this.getTransferQuantity(piece);
  }

  /**
   * dialog prompt for the transfer quantity (for non-rolled items) or pass along the piece quantity for rolled
   */
  getTransferQuantity(piece: InventorySummaryDetail): void {
    console.warn('getTransferQuantity', this.item!, piece);
    // rolled goods transfer the entire roll
    if (this.item!.isRolledGood) {
      this.createPendingTransfer(piece, piece.QtyAvailableForShipment);
    }

    // memo samples, prompt user for quantity
    else {
      let dialogRef = this.dialog.open(this.getTransferQuantityDialog, {
        data: {
          piece: piece,
          enterKeyHandler: () => dialogRef.close(true)
        }
      });

      dialogRef.afterOpened().subscribe(() => (<any>this.transferQuantity).focus());
      dialogRef.afterClosed().subscribe(response => {
        if (!response) {
          this.prepareForNextItemInput();
          return;
        }

        if (response === 'max-quantity') {
          this.createPendingTransfer(piece, piece.QtyOnHand);
        } else {
          this.createPendingTransfer(piece, Number.parseInt(this.transferQuantity.value));
        }

        this.prepareForNextItemInput();
      });
    }
  }

  /**
   * Open an alert dialog with the given message and cancel the pending transfer
   */
  alertAndCancel(message: string, transfer?: TransferDetail): void {
    this.dialog.open(AlertDialog, {
      data: {
        icon: 'error',
        message: message,
        buttonText: 'Ok',
        sound: Sound.ErrorBeep
      }
    }).afterClosed().subscribe(this.focusInput);

    // remove the pending item from the batch collection array
    if (transfer) this.cancelPendingTransfer(transfer);
  }

  /**
   * Set up the pending transfer for the given source piece
   */
  createPendingTransfer(piece: InventorySummaryDetail | null, quantity: number): void {
    if (piece) {
      // initialize transfer detail
      let transfer = new TransferDetail();
      transfer.InventoryID = this.item!.InventoryID;
      transfer.LotSerialNbr = piece.LotSerialNbr;
      transfer.FromLocationID = piece.OriginalLocationID || '';
      transfer.Qty = quantity;
      transfer.UOM = piece.BaseUOM;
      // this.pendingTransfers = this.pendingTransfers.concat(transfer);

      // add at beginning of array
      this.pendingTransfers.unshift(transfer);
      // update object to trigger UI update
      this.pendingTransfers = this.pendingTransfers.concat([]);

      this.isDirty = true;
    }

    // this.prepareForNextItemInput();
  }

  /**
   * reset the entry form and dialog inputs and set focus to get the next scan
   */
  prepareForNextItemInput() {
    setTimeout(() => {
      this.scannerInput.get('Item')!.setValue(null);
      this.scannerInput.get('LotSerNbr')!.setValue(null);
      this.transferQuantity.setValue(null);
      (<any>this.scannerInput.get('Item')!).focus();
    }, 10);
  }

  /**
   * Returns a promise that is resolved when all async operations for the scanned in QR codes have completed
   */
  waitForPendingPiecesToComplete(): Promise<void> {
    if (this._pieceSelectCount == 0) return Promise.resolve();

    let snackbarRef = this.snackBar.openFromComponent(FeedbackSnackbarComponent, { data:
      { message: "Slow your Roll\nWaiting for background operations to complete" }
    });

    return new Promise<void>(resolve => {
      const self = this;
      const wait = () => {
        if (self._pieceSelectCount == 0) {
          snackbarRef.dismiss();
          resolve();
        }
        setTimeout(wait, 1000);
      }
      wait();
    });
  }

  /**
   * move the pending details to the actual transfer document and set the transfer-to location id
   */
  stagePendingTransfers(transferToLocationID: string) {
    this.waitForPendingPiecesToComplete().then(() => {

      // check for no pending transfer items, alert, return
      if (this.pendingTransfers.length == 0) {
        this.dialog.open(AlertDialog, {
          data: {
            icon: 'error',
            message: "No transfer details are pending\nScan items to transfer first"
          }
        });
        this.prepareForNextItemInput();
        return;
      }

      // actually being moved -- not already in 'to location'
      let actuallyTransfered = this.pendingTransfers
        .filter(transfer => transfer.FromLocationID != transferToLocationID);

      let count = actuallyTransfered.length
      let inSameLocation = this.pendingTransfers
        .filter(transfer => transfer.FromLocationID == transferToLocationID).length;

      let message = count > 0
        ? count + " item" + (count > 1 ? 's' : '') + " moved to " + transferToLocationID
        : "";
      if (inSameLocation > 0) message += "\n" + inSameLocation + " item" + (inSameLocation > 1 ? 's' : '') + " already in " + transferToLocationID;
      this.snackBar.open(message, undefined, { duration: 5000 });

      // assign 'to location'
      actuallyTransfered
        .forEach(transfer => transfer.ToLocationID = transferToLocationID);

      this.transfer.Details = this.transfer.Details.concat(actuallyTransfered);
      this.pendingTransfers = [];
      this.item = undefined;

      this.prepareForNextItemInput();

    });
  }

  /**
   * remove a pending transfer detail
   */
  cancelPendingTransfer(transfer: TransferDetail) {
    let index = this.pendingTransfers.indexOf(transfer);
    this.pendingTransfers.splice(index, 1);
    this.pendingTransfers = this.pendingTransfers.concat(); // force refresh of UI table
  }

  /**
   * Save and Release the transfer in Acumatica
   */
  releaseTransfer() {
    this.dialog.open(ConfirmationDialog, {
      data: {
        message: "Release the Transfer to Acumatica?"
      }
    }).afterClosed().subscribe(answer => {
      if (answer) {
        this.logger.log(this.acumatica.username, ['Bin Transfer'], JSON.stringify(this.transfer));

        this.transfers.put(this.transfer, { loader: "Creating Transfer Document" }).subscribe(savedTransfer => {
          this.transfers.Release(savedTransfer, { message: "Release Transfer" }).subscribe(() => {
            this.isDirty = false;
            this.router.navigate(['/']);
          });
        });
      }
    });
  }

  /**
   * open dialog to prompt user to select from list of available source / from bin locations
   */
  selectSourceLocation(item: StockItem, pieces: InventorySummaryDetail[]): Observable<InventorySummaryDetail | null> {
    this.selectPieceFromLocation.setValue(null);

    return new Observable<InventorySummaryDetail | null>(observer => {
      let data = {
        item: item,
        pieces: pieces,
        errorMessage: '',
        receiveSourceLocation: (value: string) => {
          value = value.trim().toUpperCase();
          let piece = pieces.find(piece => piece.LocationID?.trim().toUpperCase() == value);
          if (piece) {
            dialogRef.close();
            observer.next(piece);
          }
          else {
            this.audio.play(Sound.ErrorBeep);
            data.errorMessage = 'Invalid Location "' + value + '"';
          }
        }
      };

      let dialogRef = this.dialog.open(this.selectSourceLocationDialog, {
        data: data
      });

      dialogRef.afterOpened().subscribe(() => (<any>this.selectPieceFromLocation).focus());
      dialogRef.afterClosed().subscribe(() => observer.complete());
    });
  }

  /**
   * open dialog to prompt for item to be moved and new home primary bin location
   */
  ChangePrimaryBin() {
    let dialogRef = this.dialog.open(this.changePrimaryBin, {
      data: { }
    });

    dialogRef.afterOpened().subscribe(() => (<any>this.rehomeInventoryID).focus());
    dialogRef.afterClosed().subscribe(response => {
      if (!response) {
        this.prepareForNextItemInput();
        return;
      }

      let inventoryID = this.rehomeInventoryID.value.trim();
      let locationID = this.rehomeLocationID.value.trim();
      this.dialog.open(ConfirmationDialog, {data:{
        message:`Change Primary Bin of\n${inventoryID}\nto\n${locationID}`,
        confirmText: 'Yes, Re-home',
        cancelText: 'No, Cancel'
      }}).afterClosed().subscribe(response => {
        if(!response) return;

        let rehome = new StockItem();
        rehome.InventoryID = inventoryID;
        rehome.DefaultIssueFrom = locationID;
        this.stockItems.put(rehome);
      })

      this.prepareForNextItemInput();
    });
  }
  UpdateRehomeItem() {
    if(!this.rehomeInventoryID.value) return;

    this.stockItems.get(this.rehomeInventoryID.value, {loader:null}).subscribe(item => {
      this.rehomeItemCurrentBin = item.DefaultIssueFrom || undefined;
    });
  }
  rehomeItemCurrentBin?: string;
}